module.exports = __webpack_public_path__ + "img/ms_teams-logo.0b2af83c.svg";